const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getToken = () => sessionStorage.getItem("hcd_session");
export const setToken = (t) => sessionStorage.setItem("hcd_session", t);
export const clearToken = () => sessionStorage.removeItem("hcd_session");

export async function apiFetch(path, options = {}) {
  const token = getToken();
  const isForm = options.body instanceof FormData;
  const headers = { ...(isForm ? {} : { "Content-Type": "application/json" }),
                    ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, { ...options, headers });
  if (res.status === 401) clearToken();
  return res;
}
